/*
 * @Author: Teemo Ding
 * @Date: 2021-08-04 16:12:21
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-07 09:54:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerList/index.tsx
 */
import { request_saveCustomerDetail } from '@/src/request/customer/customerDetail';
import { xor } from 'lodash';
import qs from 'query-string';
import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import Modal from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
import { EFilterType } from 'src/pages/CustomerDatabaseConfig/CustomerList/Components/AdvancedFilter';
//import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import { useI18n } from 'src/hooks/useRouterChange';
import { getFilterOptions } from 'src/request/customer/list';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import CommonTable from './Components/CommonTable';
import Export from './Components/Export';
import SubscriberTable from './Components/SubscriberTable';
import { EType } from './tools';
import { generatePromotions } from 'src/pages/CustomerDatabaseConfig/tools';
export { EType };

const permissions = () => {
  const view_all_customers_listing_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerGeneral,
        operation: EnumOperation.view_all_customers_listing_page,
      }),
    ],
  });
  const add_customer = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerGeneral,
        operation: EnumOperation.add_customer,
      }),
    ],
  });

  const canView = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.access_page_and_view_customer_details_page,
      }),
    ],
  });

  return {
    view_all_customers_listing_page,
    add_customer,
    canView,
  };
};

const tabsConfig = ({ getI18n }) => [
  //定义tabs列表
  { name: getI18n('customerList.customerList.all'), key: EType.All },
  { name: getI18n('customerList.customerList.new'), key: EType.New },
  {
    name: getI18n('customerList.customerList.returning'),
    key: EType.Returning,
  },
  {
    name: getI18n('customerList.customerList.abandonedCheckouts'),
    key: EType.AbandonedCheckout,
  },
  {
    name: getI18n('customerList.customerList.subscriber'),
    key: EType.Subscriber,
  },
];
// customerLayout: {
//   keys: [{ field: { uuid, name }, defaultShow, mustShow, sortable }];
// }
const allFilters = [
  EFilterType.RegisteredSalesChannel,
  EFilterType.TotalOrderAmount,
  EFilterType.RegisteredSpecificTime,
  EFilterType.OrderDate,
  EFilterType.OrderNumber,
  EFilterType.ProductsInShoppingCart,
  EFilterType.ProductPurchased,
  EFilterType.PromotionApplied,
  EFilterType.ConsentAttributes,
  EFilterType.Language,
  EFilterType.CustomerTag,
  EFilterType.AbandonCheckout,
  EFilterType.Subscription,
  EFilterType.TermsAndConditions,
];

const newFilters = [
  EFilterType.RegisteredSalesChannel,
  // EFilterType.TotalOrderAmount,
  EFilterType.RegisteredSpecificTime,
  EFilterType.OrderDate,
  //EFilterType.OrderNumber,
  EFilterType.ProductsInShoppingCart,
  // EFilterType.ProductPurchased,
  EFilterType.PromotionApplied,
  EFilterType.ConsentAttributes,
  EFilterType.Language,
  EFilterType.CustomerTag,
  EFilterType.AbandonCheckout,
  EFilterType.Subscription,
  EFilterType.TermsAndConditions,
];

const returningFilters = [
  EFilterType.RegisteredSalesChannel,
  EFilterType.TotalOrderAmount,
  EFilterType.RegisteredSpecificTime,
  EFilterType.OrderDate,
  //EFilterType.OrderNumber,
  EFilterType.ProductsInShoppingCart,
  EFilterType.ProductPurchased,
  EFilterType.PromotionApplied,
  EFilterType.ConsentAttributes,
  EFilterType.Language,
  EFilterType.CustomerTag,
  EFilterType.AbandonCheckout,
  EFilterType.Subscription,
  EFilterType.TermsAndConditions,
];

const abandonedFilter = [
  EFilterType.RegisteredSalesChannel,
  EFilterType.TotalOrderAmount,
  EFilterType.RegisteredSpecificTime,
  EFilterType.OrderDate,
  EFilterType.OrderNumber,
  EFilterType.ProductsInShoppingCart,
  EFilterType.ProductPurchased,
  EFilterType.PromotionApplied,
  EFilterType.ConsentAttributes,
  EFilterType.Language,
  EFilterType.CustomerTag,
  // EFilterType.AbandonCheckout,
  EFilterType.Subscription,
  EFilterType.TermsAndConditions,
];

export const CustomerListCommonContext = React.createContext(null);
const Provider = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { children } = props;
  const his = useHistory();
  const { customerDatabaseUuid }: any = useParams();
  const [
    fields, //setFields
  ] = React.useState([]);

  const [filterOptions, setFilterOptions] = React.useState({});
  const [infoFields, setFields] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);
  const m: any = useLocation();
  const search = qs.parse(m.search);
  const tagUuid = search.tagUuid;
  const [exportConfig, setExportConfig] = React.useState({
    selectAll: false,
    currentPageUuids: [],
    selectedUuids: [],
  });
  const [iniTag, setIniTag] = React.useState(null);
  const exportQuery = {
    tagUuid: iniTag,
  };
  //console.log('iniTag', iniTag);
  // React.useEffect(() => {
  //   if (tagUuid) {
  //     setIniTag(tagUuid);
  //     his.push(`/customerDatabase/customerList/${customerDatabaseUuid}`);
  //   }
  // }, []);
  const handleOnExportConfigChange = ({
    currentPageUuids,
    selectedUuids,
    selectAll,
  }) => {
    const _all = selectAll === exportConfig.selectAll;
    const _sUuid = xor(selectedUuids, exportConfig.selectedUuids).length === 0;
    const _cUuid =
      xor(currentPageUuids, exportConfig.currentPageUuids).length === 0;
    const isDiff = !(_all && _sUuid && _cUuid);
    // console.log('_all', _all);
    // console.log('_sUuid', _sUuid);
    // console.log('_cUuid', _cUuid);
    // console.log('isDiff', isDiff);
    if (isDiff) {
      setExportConfig({
        currentPageUuids,
        selectedUuids,
        selectAll,
      });
    }
  };

  React.useEffect(() => {
    if (tagUuid) {
      // console.log('tagUuid', tagUuid);
      setIniTag(tagUuid);
      his.push(`/customerDatabase/customerList/${customerDatabaseUuid}`);
    }
    getFilterOptions(customerDatabaseUuid).then((res: any) => {
      const {
        reportingCurrencyCode,
        availableSalesChannels,
        availableConsentAttributes,
        availableLanguages,
        availableTags,
        customerInfoFields,
        availableDiscounts,
        salesChannelTacList,
      } = res || {};

      setFields(customerInfoFields || []);
      const availablePromotions: any = generatePromotions(
        availableDiscounts,
        getI18n,
      );
      setFilterOptions({
        reportingCurrencyCode,
        salesChannels: (availableSalesChannels || []).map((i) => {
          const { name, uuid } = i;
          return { label: name, value: uuid };
        }),
        availablePromotions,
        consentAttributes: (availableConsentAttributes || []).map((i) => {
          return { label: i, value: i };
        }),
        availableLanguages: (availableLanguages || []).map((i) => {
          const { name, uuid } = i;
          return { label: name, value: uuid };
        }),
        availableTags: (availableTags || []).map((i) => {
          const { name, uuid } = i;
          return { label: name, value: uuid, tagType: i.tagType };
        }),
        salesChannelTacList: salesChannelTacList,
      });
      setLoaded(true);
    });
  }, []);

  return (
    <CustomerListCommonContext.Provider
      value={{
        fields: fields || [],
        filterOptions,
        infoFields,
        exportConfig: {
          ...(exportConfig || {}),
          query: exportQuery,
        },
        setExportConfig: handleOnExportConfigChange,
        iniTag,
        setIniTag,
      }}>
      {loaded && children}
    </CustomerListCommonContext.Provider>
  );
};
const CustomerList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const { view_all_customers_listing_page, add_customer } = permissions();
  const { modalOp } = props;
  const his = useHistory();
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;
  const { customerDatabaseUuid }: any = useParams();
  const [tabsActive, setActiveKey] = React.useState(EType.All);
  const {
    infoFields = [],
    setIniTag,
    iniTag,
  } = React.useContext(CustomerListCommonContext);

  const tabChange = (activeKey) => {
    setIniTag(null);
    setActiveKey(activeKey);
  };

  const pageLayoutProps = {
    title: getI18n('customerList.customerDetail_config.customerList'),
    addText: getI18n('customerList.customerDetail_config.addCustomer'),
    // exportFun,
    // importFun,
    exportComp: <Export tabName={tabsActive} disabled={!add_customer} />,
    addFun: () => {
      setShowModal(true);
      setModalTitle(getI18n('customerList.customerDetail_config.addCustomer'));
      setModalContent(
        <Modal
          onCancel={onModalCancel}
          fields={infoFields.map((i) => {
            return { field: i, value: [] };
          })}
          onConfirm={(e) => {
            const obj = {
              customerInfoFields: e,
              customerDBUuid: customerDatabaseUuid,
              uuid: null,
            };
            const cb = (obj) => {
              const { uuid, customerDBUuid } = obj;
              his.push(
                `/customerDatabase/customerDetail/${customerDBUuid}/${uuid}`,
              );
              onModalCancel();
            };
            return request_saveCustomerDetail(obj).then((res) => {
              return { response: res, cb };
            });
          }}
        />,
      );
    },
    tabChange,
    activeKey: tabsActive,
    tabsConfig: tabsConfig({ getI18n }),
    disableAdd: !add_customer,
    disableExport: !add_customer,
  };
  return (
    <React.Fragment>
      <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
        {tabsActive === EType.All && (
          <CommonTable
            iniTag={iniTag}
            tabName={EType.All}
            id={'CustomerListAll'}
            filters={allFilters}
            disabled={!view_all_customers_listing_page}
          />
        )}
        {tabsActive === EType.New && (
          <CommonTable
            tabName={EType.New}
            id={'CustomerListNew'}
            filters={newFilters}
            disabled={!view_all_customers_listing_page}
          />
        )}
        {tabsActive === EType.Returning && (
          <CommonTable
            tabName={EType.Returning}
            id={'CustomerListReturning'}
            filters={returningFilters}
            disabled={!view_all_customers_listing_page}
          />
        )}
        {tabsActive === EType.AbandonedCheckout && (
          <CommonTable
            tabName={EType.AbandonedCheckout}
            id={'CustomerListAbandonedCheckout'}
            filters={abandonedFilter}
            disabled={!view_all_customers_listing_page}
          />
        )}
        {tabsActive === EType.Subscriber && (
          <SubscriberTable
            tabName={EType.Subscriber}
            id={'CustomerListSubscriber'}
            disabled={!view_all_customers_listing_page}
          />
        )}
      </ListPageLayout>
    </React.Fragment>
  );
};

const _CustomerList = ModalHoc((props) => {
  return (
    <Provider>
      <CustomerList {...props} />
    </Provider>
  );
});

export default _CustomerList;
